import React, { useState, useRef, useLayoutEffect } from "react";
import { Tabs, Tab, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { PageHeader, EmptyState } from "../UI";

const MIN_FRAME_HEIGHT = 480;
const BOTTOM_GAP = 24;

const useStyles = makeStyles((theme) => ({
  panel: {
    overflow: "hidden",
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  frame: {
    display: "block",
    width: "100%",
    border: 0,
  },
}));

// Set each `embedUrl` to the report's Looker Studio embed link
// (File > Embed report) once it's available.
const REPORT_TABS = [
  {
    label: "Company Overview",
    embedUrl:
      "https://datastudio.google.com/embed/reporting/bc13b9eb-9d04-43c6-9cdf-e05eb18b1612/page/P796F",
  },
  {
    label: "Users",
    embedUrl:
      "https://datastudio.google.com/embed/reporting/333a7ce1-f038-4b64-963b-a24f8c90fc96/page/wJS4C",
  },
  {
    label: "Winners",
    embedUrl:
      "https://datastudio.google.com/embed/reporting/c42b6aa9-fa81-4b20-8fda-8efe1cb749f8/page/PfkxC",
  },
];

const Reports = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [frameHeight, setFrameHeight] = useState(MIN_FRAME_HEIGHT);
  const frameAnchorRef = useRef(null);
  const activeReport = REPORT_TABS[tab];

  useLayoutEffect(() => {
    const recalc = () => {
      if (!frameAnchorRef.current) return;
      const top = frameAnchorRef.current.getBoundingClientRect().top;
      setFrameHeight(
        Math.max(MIN_FRAME_HEIGHT, window.innerHeight - top - BOTTOM_GAP)
      );
    };

    recalc();
    window.addEventListener("resize", recalc);
    return () => window.removeEventListener("resize", recalc);
  }, []);

  return (
    <div>
      <PageHeader title="Reports" />
      <Paper className={classes.panel}>
        <Tabs
          className={classes.tabs}
          value={tab}
          onChange={(event, value) => setTab(value)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {REPORT_TABS.map((report) => (
            <Tab key={report.label} label={report.label} />
          ))}
        </Tabs>
        <div ref={frameAnchorRef}>
          {activeReport.embedUrl ? (
            <iframe
              className={classes.frame}
              style={{ height: frameHeight }}
              src={activeReport.embedUrl}
              title={activeReport.label}
              allowFullScreen
            />
          ) : (
            <EmptyState
              title="Report not connected yet"
              message={`Add the Looker Studio embed URL for "${activeReport.label}" to REPORT_TABS in Reports.jsx.`}
            />
          )}
        </div>
      </Paper>
    </div>
  );
};

export default Reports;
